"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function addI18nNamespaceToErrorMessage(namespace) {
    return function (data) {
        if (data._embedded && data._embedded.errors) {
            data._embedded.errors.forEach(function (error) {
                var firstErrorChar = error.message[0];
                var lastErrorChar = error.message[error.message.length - 1];
                if (firstErrorChar === '{' && lastErrorChar === '}') {
                    var dotsRegex = /\./g;
                    error.message = error.message.slice(1, -1).replace(dotsRegex, '_');
                }
                error.message = namespace + ":" + error.message;
            });
        }
        return data;
    };
}
exports.addI18nNamespaceToErrorMessage = addI18nNamespaceToErrorMessage;
//# sourceMappingURL=addI18nNamespaceToErrorMessage.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@utex/base-api-sdk/dist/utils/addI18nNamespaceToErrorMessage.js
// module id = 1636
// module chunks = 118